import { Component } from 'preact'
import selectize from 'selectize' // eslint-disable-line no-unused-vars
import $ from 'jquery'
import CategorySelect from './CategorySelect'
import Checkbox from './Checkbox'
import Attachments from '../category/control/Attachments'

export default class Sidebar extends Component {
  componentDidMount () {
    this.selectize()
  }

  selectize () {
    const { onUpdate, labels, public_label } = this.props
    // we need update/replace this when the forum category selector re-design is ready,
    // for now we're reusing the current selectize implementation
    $(this.articleLabel).selectize({
      create: true,
      options: labels.concat(public_label || null).map(label => {
        return { text: label, value: label }
      }),
      onInitialize: function () {
        this.setTextboxValue(public_label)
      },
      onChange: label => onUpdate('public_label', label),
      onFocus: function () {
        this.clear()
      }
    })

    $(this.publicTags).selectize({
      create: true,
      persist: false,
      plugins: ['remove_button'],
      onChange: tags => onUpdate('tags', !tags ? [] : tags.split(','))
    })
  }

  render (props) {
    const { error, forum_id, categories, allowReplies, sticky, featuredImage, tags, onUpdate, isKnowledgeBaseEnabled } = props

    return (
      <div class='article-creator__sidebar category-add_container'>
        <CategorySelect
          forum_id={forum_id}
          categories={categories}
          isKnowledgeBaseEnabled={isKnowledgeBaseEnabled}
          error={error}
          onUpdate={onUpdate}
        />
        {error && <span class='error'>{error}</span>}
        <div class='form-group'>
          <Checkbox
            label='Allow replies'
            onUpdate={status => onUpdate('open', status)}
            qaClasses='qa-open'
            checked={allowReplies}
          />
          <Checkbox
            label='Sticky topic'
            onUpdate={status => onUpdate('sticky', status)}
            qaClasses='qa-sticky'
            checked={sticky}
          />
        </div>
        <div class='form-group'>
          <label for='article-label'>Article Label</label>
          <select
            id='public-label'
            class='js-public-label js-field form-control selectize-allow-input qa-public-label'
            placeholder='Add a label next to article title'
            ref={select => {
              this.articleLabel = select
            }}
          />
        </div>
        <Attachments
          label='Featured Image'
          className='article-creator__sidebar-featured-image'
          meta={<div>Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px</div>}
          isAttachmentSelected={featuredImage !== ''}
          imageSrc={featuredImage || null}
          width={1440}
          height={640}
          onUpdate={data => onUpdate('featured_image', data ? data.source_thumb : null)}
        />
        <div>
          <label htmlFor='public-tags-label'>Public Tags</label>
          <input
            id='public-tags-label'
            class='form-control qa-article-creator-public-tags-input'
            type='text'
            placeholder='Add tags to help readers easily find this article'
            value={tags || null}
            ref={input => {
              this.publicTags = input
            }}
          />
        </div>
      </div>
    )
  }
}
